module.exports = __webpack_public_path__ + "img/icon03.ef3cbe82.png";